import { render, staticRenderFns } from "./TableMundialGroup.vue?vue&type=template&id=7015f2bf&scoped=true&"
import script from "./TableMundialGroup.vue?vue&type=script&lang=js&"
export * from "./TableMundialGroup.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialGroup.vue?vue&type=style&index=0&id=7015f2bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015f2bf",
  null
  
)

export default component.exports